/* global jQuery, elementorFrontend */

const evalElementBelowHeader = () => {
	(($) => {
		'use strict';

		const EL = '.elementor-location-header .elementor-sticky';

		function isWhiteLike(color) {
			if (!color || color === 'transparent') return true;

			const canvas = document.createElement('canvas');
			canvas.width = canvas.height = 1;
			const ctx = canvas.getContext('2d');
			ctx.fillStyle = color;
			ctx.fillRect(0, 0, 1, 1);
			const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;

			if (a < 10) return true;
			return r > 220 && g > 220 && b > 220;
		}

		function getEffectiveBgColor(el) {
			let node = el;
			while (node && node !== document.body.parentElement) {
				const bg = getComputedStyle(node).backgroundColor;
				if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
					return bg;
				}
				node = node.parentElement;
			}
			return null;
		}

		function evaluate() {
			const sticky = document.querySelector(EL);
			if (!sticky) return;

			const rect = sticky.getBoundingClientRect();
			const sampleX = rect.left + rect.width / 2;
			const sampleY = rect.bottom + 2;

			sticky.style.pointerEvents = 'none';
			const below = document.elementFromPoint(sampleX, sampleY);
			sticky.style.pointerEvents = '';

			if (!below || below === sticky || sticky.contains(below)) return;

			const tag = below.tagName.toLowerCase();
			const bgImage = getComputedStyle(below).backgroundImage;

			const isImage =
				tag === 'img' ||
				tag === 'video' ||
				(bgImage && bgImage !== 'none');
			const isWhiteBg =
				!isImage && isWhiteLike(getEffectiveBgColor(below));

			sticky.classList.toggle('mi-header--opaque', isWhiteBg);
		}

		/**
		 * Polls the DOM via MutationObserver until EL is found,
		 * then runs evaluate(). Automatically disconnects after first match
		 * or after a hard timeout to avoid observing forever on error.
		 */
		function waitForStickyThenEvaluate() {
			if (document.querySelector(EL)) {
				evaluate();
				return;
			}

			const TIMEOUT_MS = 10_000; // give up after 10 s
			let timer;

			const observer = new MutationObserver(() => {
				if (!document.querySelector(EL)) return;

				observer.disconnect();
				clearTimeout(timer);
				evaluate();
			});

			observer.observe(document.body, { childList: true, subtree: true });

			timer = setTimeout(() => {
				observer.disconnect();
				console.warn(
					'evalElementBelowHeader: sticky element not found within timeout.',
				);
			}, TIMEOUT_MS);
		}

		function init() {
			$(window).on('elementor/frontend/init', function () {
				if (
					typeof elementorFrontend !== 'undefined' &&
					elementorFrontend.hooks
				) {
					elementorFrontend.hooks.addAction(
						'frontend/element_ready/global',
						waitForStickyThenEvaluate,
					);
				} else {
					// Fallback: observe the DOM directly
					waitForStickyThenEvaluate();
				}
			});
		}

		init();
	})(jQuery);
};

try {
	evalElementBelowHeader();
} catch (error) {
	console.error(error);
}
